import Vue from 'vue'
import { mapState } from 'vuex'
import { GigApplicationStatuses } from '@/constants/gig/gigApplicationStatuses'
import { GigJobStages } from '@/constants/gig/gigJobStages'
import { GigOfferStages } from '@/constants/gig/gigOfferStages'
import { RootState } from '@/store'
import { gigJobPartiesMixin, statusesMixin } from '../mixins'

const PAST = 1
const ACTIVE = 2
const FUTURE = 3

export default Vue.extend<any, any, any, any>({
  mixins: [gigJobPartiesMixin, statusesMixin],
  data() {
    return {
      PAST,
      ACTIVE,
      FUTURE,
    }
  },
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.gigChat.application.value,
    }),
    isCancelled() {
      return this.application.status === GigApplicationStatuses.ARCHIVED && !this.application.offer
    },
    hasReview() {
      if (!this.isCompleted) return false

      return this.isEmployer ? this.application.customerLeftReview : this.application.freelancerLeftReview
    },
    statuses() {
      const statuses = []
      const offer = { title: 'Offer ', stage: PAST }
      if (!this.application?.offer || this.application.offer.stage === GigOfferStages.NEW) {
        offer.stage = ACTIVE
      }
      statuses.push(offer)

      const confirmation = { title: 'Confirmation & Deposit', stage: FUTURE }
      if (offer.stage === PAST) {
        confirmation.stage = this.application?.job ? PAST : ACTIVE
      }
      statuses.push(confirmation)

      const inProgress = { title: 'In Progress', stage: FUTURE }
      if (confirmation.stage === PAST) {
        inProgress.stage = this.application.job?.stage === GigJobStages.IN_PROGRESS ? ACTIVE : PAST
      }
      statuses.push(inProgress)

      const review = { title: 'Review', stage: FUTURE }
      if (inProgress.stage === PAST) {
        review.stage = this.hasReview ? PAST : ACTIVE
      }
      statuses.push(review)
      return [offer, confirmation, inProgress, review]
    },
  },
})
